import React from 'react';

import {
  func,
  instanceOf,
  number,
  oneOf,
  oneOfType,
  shape,
  string
} from 'prop-types';
import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';

import './Link.scss';

const colorClassName = {
  muted: 'Link_color_muted'
};

const sizeClassName = {
  small: 'Link_size_small'
};

export default class Link extends BaseComponent {
  render() {
    const {
      children,
      className,
      color,
      href,
      id,
      ref,
      size,
      style,
      tabIndex,
      target
    } = this.props;

    return (
      <a
        className={ClassNames(
          'Link',
          colorClassName[color],
          sizeClassName[size],
          `${className}`
        )}
        href={href}
        id={id}
        ref={ref}
        style={style}
        tabIndex={tabIndex}
        target={target}
      >
        {children}
      </a>
    );
  }
}

Link.propTypes = {
  color: oneOf(['muted']),
  children: string.isRequired,
  className: string,
  href: string,
  id: string,
  ref: oneOfType([func, shape({ current: instanceOf(Element) })]),
  size: oneOf(['medium', 'small']),
  style: shape({}),
  tabIndex: number,
  target: string
};

Link.defaultProps = {
  className: '',
  href: undefined,
  id: undefined,
  ref: undefined,
  size: 'medium',
  style: {},
  tabIndex: undefined,
  target: '_self'
};
